import { useRouter } from 'next/router';

export const useModelId = (): number | undefined => {
  const { query } = useRouter();
  return query.model_id !== undefined
    ? parseInt(query.model_id as string, 10)
    : undefined;
};
